import { useNavigate } from 'react-router-dom';
import { FormationType, VersionAccount } from '../types';
import { useUserContext } from '../contexts/userContext';

import { useApiService } from '@/hooks/useApiService';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@/components/ui/skeleton';

// type FormationSingleColumnProps = {
//     versionFormation: FormationType;
//     setIsModalOpen;
// };

export function FormationSingleColumn({
    versionFormation,
    setIsModalOpen,
    isModalOpen,
}: {
    versionFormation: FormationType;
    setIsModalOpen: (value: boolean) => void;
    isModalOpen: boolean;
}) {
    const { t } = useTranslation();
    const { getVersionsAccountStatuses } = useApiService();

    const { user } = useUserContext();
    const navigate = useNavigate();

    const [versionsAccountStatuses, setVersionsAccountStatuses] = useState<VersionAccount[]>([]);
    useEffect(() => {
        if (!user) {
            return;
        }
        const fetchData = async () => {
            const accountVersions = (await getVersionsAccountStatuses()) as VersionAccount[];

            setVersionsAccountStatuses(accountVersions);
        };

        fetchData().catch(console.error);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const openGettingStartedModal = () => {
        setIsModalOpen(true);
    };

    return (
        <div className="flex flex-col border rounded-2xl border-[#F2F2F2] px-8 pt-8 shadow-xl h-full">
            <img
                className="pointer-events-none -ml-2 w-[150px] select-none"
                src={`/images/${versionFormation.badge_image}`}
                alt="Archireport certified badge"
            />
            <h3 className="mt-5 text-3xl font-semibold text-text-dark">{t(versionFormation.name)}</h3>
            <p className="mt-3 text-xl font-medium text-text-grey">{t(versionFormation.description)}</p>
            {user ? (
                <div>
                    {versionFormation.available ? (
                        <button
                            className={`active:shadow-${versionFormation.theme} hover:shadow-${versionFormation.theme}active relative mt-9 w-fit cursor-pointer rounded-full bg-gradient-to-b from-gradient-ar-${versionFormation.theme}-from to-gradient-ar-${versionFormation.theme}-to px-12 py-3 text-center text-lg font-semibold text-white transition-all duration-200 ease-in-out hover:scale-101 active:scale-100 active:shadow-none`}
                            onClick={() => {
                                navigate(`/formation/${versionFormation._id}`);
                                if (isModalOpen === true) {
                                    setIsModalOpen(false);
                                }
                            }}
                        >
                            {versionsAccountStatuses.length > 0 ? t('school_continue_formation') : t('school_begin')}
                        </button>
                    ) : (
                        <button
                            className={`relative mt-9 w-fit cursor-default rounded-full bg-[#F3F3F3] px-12 py-3 text-center text-lg font-semibold text-[#66738F] transition-all duration-200 ease-in-out`}
                        >
                            {t('school_coming_soon')}
                        </button>
                    )}
                </div>
            ) : versionFormation.available ? (
                <>
                    <button
                        className={`active:shadow-${versionFormation.theme} hover:shadow-${versionFormation.theme}active relative mt-9 w-fit cursor-pointer rounded-full bg-gradient-to-b from-gradient-ar-${versionFormation.theme}-from to-gradient-ar-${versionFormation.theme}-to px-12 py-3 text-center text-lg font-semibold text-white transition-all duration-200 ease-in-out hover:scale-101 active:scale-100 active:shadow-none`}
                        onClick={openGettingStartedModal}
                    >
                        {t('Account_Connect')}
                    </button>
                </>
            ) : (
                <button
                    className={`relative mt-9 w-fit cursor-default rounded-full bg-[#F3F3F3] px-12 py-3 text-center text-lg font-semibold text-[#66738F] transition-all duration-200 ease-in-out`}
                >
                    {t('school_coming_soon')}
                </button>
            )}

            <FormationColumnLessons versionFormation={versionFormation} />
        </div>
    );
}

export function FormationColumnLessons({ versionFormation }: { versionFormation: FormationType }) {
    const { t } = useTranslation();
    const available = versionFormation.available;

    return (
        <div className="relative mt-8 flex flex-col gap-7 py-10 h-full">
            <div className="absolute bottom-0 left-[17px] top-0 z-10 h-full w-[2px] rounded-full bg-[#E0E3E9]"></div>
            {versionFormation?.lessons?.map(function (lesson, index) {
                return (
                    <div key={index} className="relative z-20 flex flex-row items-center justify-between">
                        {available ? (
                            <>
                                <div
                                    className={`flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md shrink-0`}
                                >
                                    <span className={`text-md font-bold`}>{index + 1}</span>
                                </div>
                                <div className="flex items-start">
                                    <p className="ml-6 mr-4 text-xl font-semibold text-text-dark break-words">
                                        {t(lesson.name as string)}
                                    </p>
                                </div>
                                <div className="mt-0.5 ml-auto rounded-full bg-orange-500/10 px-2.5 shrink-0">
                                    <span className="text-xs font-semibold leading-6 text-orange-500">
                                        {lesson.duration} min
                                    </span>
                                </div>
                            </>
                        ) : (
                            <div key={index} className="relative z-20 flex flex-row items-center justify-between">
                                <div
                                    className={`flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md shrink-0`}
                                >
                                    <span className={`text-md font-bold`}>{index + 1}</span>
                                </div>
                                <div className="flex flex-col space-y-3 pl-5">
                                    <Skeleton className="h-[15px] w-[250px]  rounded-xl" />
                                    <div className="space-y-2">
                                        <Skeleton className="h-4 w-[200px]" />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}
